import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AvailabilityIndexResultSchema } from '../availability/availabilityTypes';
import { authHeader, salesApiBaseUrl } from './authHeader';
export const availabilityApi = createApi({
    reducerPath: 'availabilityApi',
    baseQuery: fetchBaseQuery({
        baseUrl: salesApiBaseUrl(),
        prepareHeaders: async (headers) => {
            const auth = await authHeader();
            Object.entries(auth).forEach(([key, value]) => headers.set(key, value));
            return headers;
        }
    }),
    endpoints: builder => ({
        // POST /availability-index — one call per property + visible date window.
        // The request body (property, window, rate plans) is the cache key, so
        // paging the window re-fetches; a property scrolled off screen keeps its
        // last window cached rather than re-hitting Apaleo.
        availabilityIndex: builder.query({
            query: request => ({
                url: '/availability-index',
                method: 'POST',
                body: request
            }),
            transformResponse: (response) => AvailabilityIndexResultSchema.parse(response)
        })
    })
});
export const { useAvailabilityIndexQuery } = availabilityApi;
